import React from 'react';
import { FormattedMessage } from 'react-intl';



class ConfirmPopupComponent extends React.Component {
    
    constructor(props){
        super(props);
        this.timeOut1 = null;
        this.timeOut2 = null;
    }

    componentDidMount(){
        this.timeOut1 = setTimeout(()=>{this.confirmPopup.style.opacity = 1}, 350);
        this.timeOut2 = setTimeout(()=>{this.confirmContainer.style.transform = "scale(1)"}, 400);
    }

    componentWillUnmount(){
        clearTimeout(this.timeOut1);
        clearTimeout(this.timeOut2);
    }


    render(){
        let mess  = <div className = "popup-msg">{this.props.details.get("message")}</div>
        if(this.props.details.get("formatId")){
            mess = <div className = "popup-msg"><FormattedMessage id={this.props.details.get("message")}></FormattedMessage></div>
        }
        return(
            <div ref = {(e) => this.confirmPopup = e} className = {"confirm-popup popup-overlay" + (this.props.details.get("position")?" "+this.props.details("position"):"")} onMouseDown = {(e) => {this.props.confirmPopup({show : false})}} >
                <div className = "confirm-container" ref = {(e) => this.confirmContainer = e} onMouseDown = {(e) => {e.stopPropagation()}}>
                    <div className = "popup-body">
                        {mess}
                        <div className = "popup-btns">
                            <div className = "cancel-btn" onClick = {(e) => this.props.dispatchAction(this.props.details.get("cancelAction").toJS())}><FormattedMessage id="ca.btn"></FormattedMessage></div>
                            <div className = "ok-btn" onClick = {(e) => this.props.dispatchAction(this.props.details.get("okAction").toJS())}><FormattedMessage id="co.btn"></FormattedMessage></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}

export default ConfirmPopupComponent;


// WEBPACK FOOTER //
// ./src/components/ConfirmPopupComponent.js